module.exports = __webpack_public_path__ + "7c249891981a20eab08fe8e57c6d8788.MP3";